export default "__VITE_ASSET__CSELF1BS__"